export default "__VITE_ASSET__BoiVGf6y__"